import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { filter, get, toArray } from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import firebase from "firebase";
import {
  Typography,
  Paper,
  Box,
  Button,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core";
import Table from "../../Table";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloudDoneIcon from "@material-ui/icons/CloudDone";
import { withSnackbar } from "notistack";
import { createSubscription } from "../../../utils/db";
import { timeZoneDate } from "../../../utils/misc";

const collection = "deploymentLogs";

const tableSchema = {
  ref: collection,
  title: "Logs",
  group: "Logs",
  id: collection,
  type: "object",
  properties: {
    env: {
      type: "string",
      label: "Environment",
      component: "text",
    },
    date: {
      type: "string",
      label: "Date",
      component: "date",
    },
    uid: {
      type: "string",
      label: "User Id",
      component: "text",
    },
    displayName: {
      type: "string",
      label: "Name",
      component: "text",
    },
    email: {
      type: "string",
      label: "Email",
      component: "text",
    },
  },
};

const useStyles = makeStyles((theme) => ({}));

const DeploymentOptions = (props) => {
  const [thinking, setThinking] = useState(false);
  const [data, setData] = useState(props[collection]);
  const classes = useStyles();

  useEffect(() => {
    setData(props[collection]);
  }, [props]);

  createSubscription(collection, { limit: 50, order: ["date", "desc"] });

  const onDeployAttempt = async (env) => {
    try {
      const ref = firebase.firestore().collection(collection);
      const { uid, displayName, email } = firebase.auth().currentUser;

      const docId = ref.doc().id;
      await ref.doc(docId).set({
        env,
        date: timeZoneDate(),
        uid,
        displayName,
        email,
      });
    } catch (e) {
      props.enqueueSnackbar(
        "Error creating log entry - deployment not started",
        {
          variant: "error",
        }
      );
      console.error(e);
    }
  };

  const onError = () => {
    props.enqueueSnackbar("Deployment failed to start", {
      variant: "error",
    });
    setThinking(false);
  };

  const onSuccess = () => {
    props.enqueueSnackbar("Deployment started", {
      variant: "success",
    });
    setThinking(false);
  };

  const deploy = async (env) => {
    setThinking(true);
    onDeployAttempt(env);
    switch (env) {
      case "staging":
        try {
          await fetch(
            "https://api.vercel.com/v1/integrations/deploy/prj_XzLOuzib7PeNCpcYdZJHPKVuCAAG/0c8OYgwYru",
            { method: "POST" }
          );
          onSuccess();
        } catch (e) {
          onError();
        }
        break;
      case "production":
        try {
          await fetch(
            "https://api.vercel.com/v1/integrations/deploy/prj_XzLOuzib7PeNCpcYdZJHPKVuCAAG/t5BCu2qJsE",
            { method: "POST" }
          );
          onSuccess();
        } catch (e) {
          onError();
        }
        break;

      // no default
    }
  };

  return (
    // <DarkTheme>

    <Box p={3}>
      <Box display="flex" alignContent="center">
        <CloudDoneIcon color="primary" style={{ marginRight: "0.5rem" }} />
        <Typography variant="subtitle1">Deployments</Typography>
      </Box>

      <ExpansionPanel color="primary">
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Button
            variant="contained"
            color="primary"
            disabled={thinking}
            onClick={(e) => {
              e.stopPropagation();
              deploy("staging");
            }}
          >
            Deploy Staging
          </Button>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Box mb={2} display="block"></Box>

          <Table
            schema={tableSchema}
            data={filter(toArray(data), (item) => item.env === "staging")}
          />
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Button
            disabled={thinking}
            variant="contained"
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              deploy("production");
            }}
          >
            Deploy Production
          </Button>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Table
            schema={tableSchema}
            data={filter(toArray(data), (item) => item.env === "production")}
          />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Box>

    // </DarkTheme>
  );
};

export default connect(
  ({ dbState }) => ({
    [collection]: get(dbState, collection, {}),
  }),
  {}
)(withSnackbar(DeploymentOptions));
